import { render, staticRenderFns } from "./ClaimTable.vue?vue&type=template&id=bebe7a5c&scoped=true&"
import script from "./ClaimTable.vue?vue&type=script&lang=js&"
export * from "./ClaimTable.vue?vue&type=script&lang=js&"
import style0 from "./ClaimTable.vue?vue&type=style&index=0&id=bebe7a5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebe7a5c",
  null
  
)

export default component.exports